
































































































































































































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import SelectNodeField from '@c/controls/selectControls/SelectNodeField.vue';
import {PBearingControlModule} from '@v/system/modules/interfaces';
import TreeTable from './TreeTable.vue';
import IconButton from '@c/controls/IconButton.vue';
import router from '@/router';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import TableCheckBox from '@c/tables/TableCheckBox.vue';
import PModuleMeasurementEditDialog from '@v/system/modules/forms/PModuleMeasurementEditDialog.vue';
import {PModuleTableHeader} from '../interfaces';
import {PModuleMeasurementStore} from './pModuleMeasurementStore';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import {updateMeasurements} from '../moduleUtils';
import enumsModule from '@/store/modules/enumsModule';
import {PModuleType} from '@/enums/configs';
import {httpClient} from '@/api/baseApi';
import {EventDefaultValues} from '../../measurements/interfaces';
import PModuleButtons from './../../nodes/PModuleButtons.vue';
import nodeModule from '@/store/modules/entities/nodeModule';

@Component({
  components: {
    TreeTable,
    SelectNodeField,
    IconButton,
    CancelChangesDialog,
    TableCheckBox,
    PModuleMeasurementEditDialog,
    PModuleButtons,
  },
})
export default class BearingControlModuleForm extends Vue {
  loading = false;
  saving = false;

  valid = true;

  nodeName: any = null;

  @Prop({required: true})
  pmodule!: PBearingControlModule;

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';

  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  tahoCrmValues: any = [];

  axeValues: any = [];

  moduleDefaultValues: EventDefaultValues[] = [];

  showGearRatio = false;
  showNumAveraging = false;
  showSensitivity = false;
  showLowTahoLevel = false;
  showPaddleCount = false;
  showGostLowLevel = false;
  showGostMediumLevel = false;
  showGostHighLevel = false;
  showModulationLowLevel = false;
  showModulationMediumLevel = false;
  showModulationHighLevel = false;

  get measurementsStore() {
    return new PModuleMeasurementStore(this.pmodule);
  }

  measurementDialog = PModuleMeasurementEditDialog;

  measurementsHeaders: PModuleTableHeader[] = [
    {
      text: 'Измерение',
      value: 'measurementDescription',
      sortable: false,
    },
    {
      text: 'В. гр. предупреждения',
      value: 'topWarningBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. опасного значения',
      value: 'topDangerBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. ошибки',
      value: 'topErrorBoundary',
      sortable: false,
    },
  ];

  async onSave() {
    this.pmodule.measurements = this.pmodule.measurements.filter((x: any) => x.isActive === true);
    this.valid = await (this.$refs.form as any).validate();

    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && (await this.$vuetify.goTo(error as HTMLElement));
      return;
    }

    this.$emit('save');
  }

  async loadMeasurements() {
    // Подгружаем список измерений, ещё не использованных в таблице
    await measurementsStoreModule.fetchAll();
    if (this.pmodule.measurements) {
      const newEntities = measurementsStoreModule.entities.filter(
        (x: any) =>
          x.moduleType === this.pmodule.type &&
          !this.pmodule.measurements.some((y: any) => y.measurementId == x.id),
      );
      // если такие измерения найдены, добавляем их в таблицу измерений модуля
      if (newEntities.length > 0) {
        updateMeasurements(this.pmodule.measurements, newEntities);
      }
    }
  }

  async setValues(module: any) {
    const moduleParametersResponse: {data: any} = await httpClient.get(`${module.url}`);
    const values = moduleParametersResponse.data;
    return values.map((x: any) => ({
      guid: x.guid,
      name: x.name,
    }));
  }

  async getDefaultValues() {
    const tahoModule = enumsModule.moduleTypes.find(v => v.value === PModuleType.DtcpTahoModule);
    const crmModule = enumsModule.moduleTypes.find(v => v.value === PModuleType.CrmModule);
    const axeModule = enumsModule.moduleTypes.find(
      v => v.value === PModuleType.DtcpAccelerometerModule,
    );

    if (tahoModule) this.tahoCrmValues = await this.setValues(tahoModule);
    if (crmModule) this.tahoCrmValues = this.tahoCrmValues.concat(await this.setValues(crmModule));

    if (axeModule) {
      this.axeValues = await this.setValues(axeModule);
    }
  }

  nodeFieldClick(index: number) {
    router.push(`/nodes/${this.pmodule.nodes ? this.pmodule.nodes[index].node_id : 0}`); //TODO: fix it?
  }

  async created() {
    if (this.pmodule.nodes && this.pmodule.nodes.length) {
      const totalNodeNames: {title: string; value: number}[] = [];
      const nodesIds: number[] = this.pmodule.nodes.map((item, index) => index);

      const getNameNode = async (idx: number) => {
        if (this.pmodule.nodes) {
          const {data} = await nodeModule.edit(this.pmodule.nodes[idx].node_id);
          return {title: data.name, value: data.id ?? 0};
        }
      };

      for (const item of nodesIds) {
        const result = await getNameNode(item);
        if (result) {
          totalNodeNames.push(result);
        }
      }
      this.nodeName = totalNodeNames;
    }
    this.getDefaultValues();
    //для тех измерений, которые уже сохранены, проставляем isActive = true и isNew = false
    this.pmodule.measurements.forEach((elem: any) => {
      if (!elem.isNew) {
        (elem.isActive = true), (elem.isNew = false);
      }
    });

    await this.loadMeasurements();
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  // Действия при изменении поля
  async onChange() {
    this.changed = true;
  }

  get cancelChangesDialog() {
    return this.$refs.cancelChangesDialog as any;
  }

  back() {
    // если были внесены изменения на форме
    if (this.changed) {
      this.cancelChangesDialog.open('/modules');
    } else router.push('/modules');
  }
}
